import React from "react";
import { useTranslation } from "../../../../context/Internationalization";
import Table from "../../../../Components/Table/Table";
import FieldsTableRow from "./FieldsTableRow";

const schema = (t) => [
  {
    id: "photo",
    label: t("field_photo"),
  },
  {
    id: "name",
    label: t("field_name"),
  },
  {
    id: "location",
    label: t("location"),
  },
  {
    id: "actions",
    label: "",
  },
];

const FieldsTable = ({ fields, menuActions, lastElementRef }) => {
  const { t } = useTranslation();
  const rowElement = (field, index) => (
    <FieldsTableRow
      key={field._id}
      lastElementRef={lastElementRef}
      field={field}
      index={index}
      menuActions={menuActions}
    />
  );

  return <Table rows={fields} columns={schema(t)} rowElement={rowElement} />;
};

export default FieldsTable;
